import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { CheckBoxModule } from '../../../check-box/check-box.module';
import { DateBoxModule } from '../../../date-box/date-box.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ListModule } from '../../../list/list.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { PaginationModule } from '../../../pagination/pagination.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { SearchAnnouncementComponent } from './search-announcement.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputBoxModule,
    SelectBoxModule,
    DateBoxModule,
    CheckBoxModule,
    ButtonModule,
    TooltipModule,
    ListModule,
    PaginationModule,
    ScrollViewModule,
    LoadingPanelModule,
    BlockModalDragModule,
  ],
  declarations: [SearchAnnouncementComponent],
  exports: [SearchAnnouncementComponent],
})
export class SearchAnnouncementModule {}
